import { docgenEnum } from '@polestar/component-warehouse-react/helpers/docgenInterface';
import { cssCustomPropPrefix } from '@polestar/component-warehouse-react/helpers/style';
import { MotionEasings, createCSSTransition, cubicBezier, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import { createCustomSpacing } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
export const primaryNavigationId = 'primary-navigation';
export const secondaryNavigationId = 'secondary-navigation';
// The duration (in milliseconds) it takes before the overlay triggers the menu to close on hover
export const overlayHoverGraceTime = 300;
export var MegaMenuMotionDurations;
(function (MegaMenuMotionDurations) {
    // none = 0,
    // xxSlow = 800,
    MegaMenuMotionDurations[MegaMenuMotionDurations["d650"] = 650] = "d650";
    // xSlow = 500,
    MegaMenuMotionDurations[MegaMenuMotionDurations["d450"] = 450] = "d450";
    // slow = 400,
    MegaMenuMotionDurations[MegaMenuMotionDurations["d350"] = 350] = "d350";
    // normal = 300,
    MegaMenuMotionDurations[MegaMenuMotionDurations["fast"] = 200] = "fast";
    MegaMenuMotionDurations[MegaMenuMotionDurations["d150"] = 150] = "d150";
    // xFast = 100,
})(MegaMenuMotionDurations || (MegaMenuMotionDurations = {}));
// the duration (in milliseconds) to avoid accidental hovers/mouse enters of items in the main navigation
export const hoverGracePeriod = 150;
export const fadeTransitions = `${MegaMenuMotionDurations.fast}ms ${cubicBezier(MotionEasings.linear)}`;
export const flyoutPanelTransitionDuration = MegaMenuMotionDurations.d650;
export const flyoutPanelTransition = createCSSTransition('translate', cubicBezier([0.43, 0.01, 0.27, 0.99]), flyoutPanelTransitionDuration);
export const flyoutDesktopClipPathTransition = createCSSTransition('clip-path', cubicBezier([0.43, 0, 0.42, 1]), MegaMenuMotionDurations.d450);
export const linkHoverTransition = createCSSTransition('opacity', MotionEasings.easeInOut, MegaMenuMotionDurations.d150);
export const disappearingHeaderTransition = createCSSTransition('translate', MotionEasings.easeInOut, MegaMenuMotionDurations.d350);
export const tabletInlineSize = '50%';
/**
 * @internal
 */
export const megaMenuZIndexes = {
    navigationContainer: 1,
    flyout: 2,
    sharedCloseButton: 3,
};
/**
 * TODO: This needs to be globalised and needs TLC from the team how to use this in the future
 */
export const cwRTLTranslate = `${cssCustomPropPrefix}-rtl-translate`;
const cssCustomPropMegaMenuPrefix = `${cssCustomPropPrefix}-mega-menu`;
const cssCustomPropInternalMegaMenuPrefix = `${cssCustomPropPrefix}-internal-mega-menu`;
export var MegaMenuCSSCustomProperties;
(function (MegaMenuCSSCustomProperties) {
    /**
     * @internal do not use
     */
    MegaMenuCSSCustomProperties["isLightTheme"] = "--cw-internal-mega-menu-is-light-theme";
    /**
     * The height of the MegaMenu bar
     */
    MegaMenuCSSCustomProperties["blockSize"] = "--cw-mega-menu-block-size";
    /**
     * The height of the sub-navigation slot
     */
    MegaMenuCSSCustomProperties["subNavigationHeight"] = "--cw-mega-menu-sub-nav-height";
    /**
     * The amount of space until the MegaMenu bar from the top of the window
     */
    MegaMenuCSSCustomProperties["menuTopOffset"] = "--cw-mega-menu-top-offset";
    /**
     * @internal do not use
     */
    MegaMenuCSSCustomProperties["background"] = "--cw-internal-mega-menu-background";
    /**
     * @internal do not use
     */
    MegaMenuCSSCustomProperties["color"] = "--cw-internal-mega-menu-color";
    /**
     * @internal do not use
     */
    MegaMenuCSSCustomProperties["divider"] = "--cw-internal-mega-menu-divider";
    /**
     * @internal do not use
     */
    MegaMenuCSSCustomProperties["tabletMaxInlineSize"] = "--cw-internal-mega-menu-tablet-max-inline-size";
    /**
     * Provide a 0 / 1 to determine if the header is hidden or visible.
     */
    MegaMenuCSSCustomProperties["hideHeader"] = "--cw-mega-menu-hide-header";
    /**
     * Provide the current height of the visible area of the MegaMenu without the sub-navigation slot height
     */
    MegaMenuCSSCustomProperties["safeAreaHeight"] = "--cw-mega-menu-safe-area-height";
    /**
     * Provide the initial height (NOT changed when scrolling) of the visible area of the MegaMenu without the sub-navigation slot height.
     */
    MegaMenuCSSCustomProperties["maxSafeAreaHeight"] = "--cw-mega-menu-max-safe-area-height";
    /**
     * @internal do not use
     */
    MegaMenuCSSCustomProperties["flyoutTransitionDuration"] = "--cw-internal-mega-menu-flyout-transition-duration";
    /**
     * @internal do not use
     */
    MegaMenuCSSCustomProperties["variant"] = "--cw-internal-mega-menu-variant";
})(MegaMenuCSSCustomProperties || (MegaMenuCSSCustomProperties = {}));
export const MegaMenuCSSCustomPropertiesInterface = docgenEnum('MegaMenuCSSCustomProperties', MegaMenuCSSCustomProperties);
/**
 * This is needed for SSR to ensure a minimal / initial value to render from until JS is loaded fully.
 *
 * @internal
 */
export const megaMenuMinimalSafeAreaHeight = createCustomSpacing(56 / 16);
/**
 * @internal
 */
export const flyoutDesktopBlockSize = `min(${createCustomSpacing(424 / 16)}, 90vh)`;
/**
 * @internal
 * Pixel value for the height of the mask area
 */
export const megaMenuScrollHintSize = 80;
/**
 * @internal
 * Pixel value to trigger the visibility of the top or bottom gradient effect
 */
export const megaMenuScrollHintTriggerSize = 40;
/**
 * @internal
 * The amount of time to wait extra to ensure that the animation is not triggered after the useBreakpointChanged hook
 */
export const megaMenuBreakpointCheckDelay = 50;
